import { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { FaCalendarAlt} from "react-icons/fa";
import { useSelector } from "react-redux";
import BarraMenuHz from "../../../components/BarraMenoHz";
import LocalMsgModalSpinner from "../../../components/LocalMsgModalSpinner";
import MsgDialog from "../../../components/MsgDialog";
import MsgModalDialogEspecial from "../../../components/MsgModalDialogEspecial";
import * as env from '../../../env';
import { httpApiGetText } from "../../../lib";
import { exportToExcel } from "../../../util";


/************************************/
const DescargaMasivaPage = () =>{

    let formData: {fAdesde:string, fMdesde: string, fAhasta: string, fMhasta: string} = {fAdesde:"", fMdesde: "", fAhasta: "", fMhasta: ""};     
    const emp: any = useSelector((state: any) => state.emp);
    let arrayCentros: {idx: number, id: string, estado: boolean, texto:string}[] = [];



    const manejadorFechas = (fd: any) =>{

        formData = fd;
    }

    const manejadorCHK = (arr: any) =>{
        arrayCentros = [];
        arr.map((valor: any)=>{
            if (valor.estado){
                arrayCentros.push(valor);
            }
        })
    }

    /**********************************/
    const RangosFechas = (props: any) => {

        const [fdate, setFdate] = useState({fAdesde:"", fMdesde: "", fAhasta: "", fMhasta: ""});
        const [showMsgDlg, setShowMsgDlg] =  useState(false); 
        const [sHCarga, setSHCarga] =  useState(false);   
        const [msgDlgShowApiResponse, setMsgDlgShowApiResponse] =  useState(false);   
        const [msgRespuestInv, setMsgRespuestInv] =  useState("");          

        const hndlrFdesde = (evnt: any) => {

            const f: Date = evnt.target.value; 
            const yy = f.toString().split('-')[0];
            const mm = f.toString().split('-')[1];
            const fd = {...fdate, fAdesde: yy, fMdesde: mm};
            setFdate(fd);
            props.hndlrFD(fd);
        }

        const hndlrFhasta = (evnt: any) => {

            const f: Date = evnt.target.value; 
            const yy = f.toString().split('-')[0];
            const mm = f.toString().split('-')[1];
            const fd = {...fdate, fAhasta: yy, fMhasta: mm};
            setFdate(fd);
            props.hndlrFH(fd);            
        }  

        const hndlrBtnExport = async () => {
            if((formData.fAdesde !== "") && (formData.fAhasta !== "") && (arrayCentros.length > 0)){
                if (formData.fAhasta < formData.fAdesde){
                    setShowMsgDlg(true);
                }else{
                    if (formData.fMhasta < formData.fMdesde) {
                        setShowMsgDlg(true);
                    }else{
                        setSHCarga(true);
                        let centros: string = "";
                        arrayCentros.map((valor: any)=> centros+=valor.id.split("-")[1] + "|");
                        centros = centros.substring(0, centros.length-1);
                        const recurso = `${env.REACT_APP_API_URL}/api/ReporteInventarioMasivo?Pais=CL&PeriodoDesde=${formData.fAdesde}${formData.fMdesde}&PeriodoHasta=${formData.fAhasta}${formData.fMhasta}&Diferencias=0&Centros=${centros}`;     
                        const response = await httpApiGetText(recurso,{
                            'Content-Type': 'application/json',
                            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
                            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
                        });
                        setSHCarga(false);
                        if (response.code >= 400){
                            setMsgRespuestInv("No se pudo realizar la operación de descarga.");
                        }else{
                            setMsgRespuestInv("La descarga se ha realizado con éxito!!!.");
                            const arrData = JSON.parse(response.message);
                            exportToExcel("descargaMasivaTable.xls", arrData);
                        }
                        setMsgDlgShowApiResponse(true);                    
                    }
                }
            }else{
                setShowMsgDlg(true);
            }
        }

        return(
            <div className="row  justify-content-center border-0 rounded shadow mb-2 bg-white" >
                <div className="   col-md-12 col-lg-4 " >
                    <div className=" flex-row justify-content-center gap-5 mt-2 mb-2">
                        <div className="align-middle">
                            <FaCalendarAlt className="h5" /> 
                            <label  className="ms-2" >Desde</label>
                        </div>
                        <div>
                            <input type="month" id="fdesde" size={8} className="form-control ms-2"
                                value={`${fdate.fAdesde}-${fdate.fMdesde}`}
                                onChange={hndlrFdesde} 
                                min="1990-01" max="9999-12"
                            />
                        </div>
                    </div>
                </div>
                <div className="   col-md-12 col-lg-4 " >
                    <div className=" justify-content-center gap-5  mt-2 mb-2" >
                        <div className="align-middle">
                            <FaCalendarAlt  className="h5"/> 
                            <label  className="ms-2" >Hasta</label>
                        </div>
                        <div >
                            <input type="month" id="fhasta" size={8}  className="form-control ms-2"
                                value={`${fdate.fAhasta}-${fdate.fMhasta}`}
                                onChange={hndlrFhasta} 
                                min="1990-01" max="9999-12"
                            />
                        </div>
                    </div>
                </div>      
                <div className=" col-md-12 col-lg-4 d-flex align-items-center justify-content-center" >              
                    <Button type="button" className="btn btn-lg border-0 " style={{backgroundColor:"#16D39A"}} onClick={()=>hndlrBtnExport()}>
                        Exportar
                    </Button>
                </div>   
                {showMsgDlg && <MsgDialog
                    Show={showMsgDlg}
                    Title="Descarga Masiva"
                    Message="Debe seleccionar un rango de fechas válidas y al menos un centro para exportar"
                    BtnOkName="Aceptar"
                    BtnNokName=""
                    HandlerClickOk={()=>setShowMsgDlg(false)}
                    Icon="!"
                    HanlerdClickNok={null}
                />}   
                {/*********** cuadro de dialogo para msj de api **********/}
                {msgDlgShowApiResponse && <MsgModalDialogEspecial
                    Show={msgDlgShowApiResponse}
                    Title={`Descarga masiva`}
                    Icon="x"
                    Message={msgRespuestInv}
                    BtnOkName="Aceptar"
                    BtnNokName=""
                    HandlerClickOk={()=>setMsgDlgShowApiResponse(false)}
                    HanlerdClickNok={null}
                />}  
                {sHCarga && <LocalMsgModalSpinner 
                    Show={sHCarga}
                    text="Un momento porfavor, procesando..."
                    color="#FF7588"
                />}                                                          
            </div>
        );
    }

    /************************************/
    const CheckComponents = (props: any) =>{

        let arrToObj: {idx: number, id: string, estado: boolean, texto:string}[] = [];
        let [arrChks, setArrChks] = useState(arrToObj);

        useEffect(()=>{
            const init = () =>{
                arrChks = [];
                props.data.map((valor:string, index: number)=>{
                    const prb = {idx: index, id:("chk-" + valor.split(" - ")[0] + "-" + index), estado: false, texto: valor};
                    arrChks.push(prb);
                });
                setArrChks([...arrChks]);            
            }

            init();
        },[]);

        const hndlrCHK = (evnt: any, idx: number) =>{
            let newCheck = [...arrChks];
            if (evnt.target.checked){  
                newCheck[idx].estado = true
            }else{
                newCheck[idx].estado = false
            }     
            setArrChks([...newCheck]);
            props.hndlrCheck(arrChks);           
        } 

        const recorreCHK = (state: boolean) =>{
            if (state){
                let newCheck = [...arrChks];
                newCheck.map((dato: {idx: number, id: string, estado: boolean, texto:string}, index: number) => newCheck[index].estado = state);
                setArrChks([...newCheck]);
                arrayCentros = [...newCheck];                
            }else{ 
                let newCheck = [...arrChks];
                newCheck.map((dato: {idx: number, id: string, estado: boolean, texto:string}, index: number) => newCheck[index].estado = state);
                setArrChks([...newCheck]);                              
                arrayCentros = []; 
            }
        }         

        return(
            <Container className=" border rounded shadow pt-3 pb-3 gap-4  bg-white" >
                <div className="d-flex gap-2">
                    <div>
                        <input className="form-check-input" type="checkbox" onChange={(e: any)=>recorreCHK(e.target.checked)} />                        
                    </div>
                    <div>Centros Disponibles</div>
                </div>
                <div className=" border rounded" style={{height: "70vh", overflowY:"scroll"}}>
                        {
                            arrChks.map((dato: {idx: number, id: string, estado: boolean, texto:string}, index: number)=> 
                                <div className="form-check" key={index}  >
                                    <input className="form-check-input" type="checkbox" 
                                        value={`${dato.idx}`} id={`${dato.id}`} 
                                        onChange={(e: any)=>hndlrCHK(e, index)}
                                        checked={dato.estado}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                        {`${dato.texto}`}
                                    </label>
                                </div>
                            )
                        }
                </div>
        </Container>
        );
    }

    return(
        <Container fluid>
        <BarraMenuHz/>  
            <div>
                <div className="text-primary ms-3 mt-3">
                            Home / Consulta / Descarga Masiva de Inventario
                </div>  
                <div className="h4 mt-4 mb-4 ms-3">DESCARGA MASIVA DE INVENTARIO</div>
            </div> 

            <div className="container">
                <RangosFechas hndlrFD={manejadorFechas} hndlrFH={manejadorFechas} />           
                <CheckComponents data={emp.centros} hndlrCheck={manejadorCHK}  />                
            </div>                    
        </Container>
    );
}

export default DescargaMasivaPage;
